import React, { useEffect, useState, useRef } from 'react';
import './intro.css';
import bg from '../../assets/avikal_image.jpg';
import { Link } from 'react-scroll';

const TITLES = ['AI Engineer', 'ML Engineer', 'Data Scientist', 'Data Engineer', 'AWS Certified', 'Healthcare AI', 'Multimodal AI', 'LLM Pipelines', 'Cloud Infrastructure'];

const CertModal = ({ onClose }) => (
  <div className="certOverlay" onClick={onClose}>
    <div className="certModal" onClick={e => e.stopPropagation()}>
      <div className="certModalHeader">
        <span className="certModalTitle">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="8" r="6"/><path d="M8.56 14.28L7 22l5-3 5 3-1.56-7.72"/>
          </svg>
          AWS Certified Data Engineer – Associate (DEA-C01)
        </span>
        <button className="certModalClose" onClick={onClose} aria-label="Close">✕</button>
      </div>
      <div
        className="certImageWrap"
        onContextMenu={e => e.preventDefault()}
      >
        <img
          src="/aws-certificate.png"
          alt="AWS Certified Data Engineer Certificate"
          className="certImage"
          draggable={false}
          onContextMenu={e => e.preventDefault()}
        />
      </div>
      <p className="certModalFooter">AWS Certified Data Engineer – Associate · Issued June 2025</p>
    </div>
  </div>
);

const Intro = () => {
  const [titleIndex, setTitleIndex] = useState(0);
  const [displayed, setDisplayed] = useState('');
  const [deleting, setDeleting] = useState(false);
  const [glitch, setGlitch] = useState(false);
  const [visible, setVisible] = useState(false);
  const [certOpen, setCertOpen] = useState(false);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const handleKey = (e) => { if (e.key === 'Escape') setCertOpen(false); };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, []);

  // Entrance
  useEffect(() => { setTimeout(() => setVisible(true), 100); }, []);

  // Typewriter
  useEffect(() => {
    const current = TITLES[titleIndex];
    if (!deleting && displayed === current) {
      timeoutRef.current = setTimeout(() => setDeleting(true), 2000);
    } else if (deleting && displayed === '') {
      setDeleting(false);
      setTitleIndex((i) => (i + 1) % TITLES.length);
    } else {
      timeoutRef.current = setTimeout(() => {
        setDisplayed(deleting
          ? current.slice(0, displayed.length - 1)
          : current.slice(0, displayed.length + 1)
        );
      }, deleting ? 40 : 80);
    }
    return () => clearTimeout(timeoutRef.current);
  }, [displayed, deleting, titleIndex]);

  // Glitch on name periodically
  useEffect(() => {
    const interval = setInterval(() => {
      setGlitch(true);
      setTimeout(() => setGlitch(false), 400);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section id='intro'>
      <div className="introGrid"></div>

      <div className={`introContent ${visible ? 'visible' : ''}`}>
        <div className="introBadge introBadgeClickable" onClick={() => setCertOpen(true)} title="Click to view certificate">
          <span className="introBadgeDot"></span>
          <span className="introBadgeText">
            <span className="termPrompt">$ </span>aws certify --exam DEA-C01 --level associate
          </span>
          <span className="introBadgeCheck">✓</span>
          <span className="introBadgeViewHint">
            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
            </svg>
            view
          </span>
        </div>

        {certOpen && <CertModal onClose={() => setCertOpen(false)} />}

        <span className='hello'>Hello, I'm</span>

        <span className={`introName ${glitch ? 'glitch' : ''}`} data-text="Avikal Singh">
          Avikal Singh
        </span>

        <div className="introTitleRow">
          <span className="termCaret">&gt;</span>
          <span className='introTitle'>{displayed}</span>
          <span className="cursor">▋</span>
        </div>

        <p className='introPara'>
          I build multimodal AI systems, LLM pipelines, and cloud infrastructure
          across healthcare, manufacturing, and data engineering — from model
          development to production deployment.
        </p>

        <div className="introStats">
          <div className="introStat">
            <span className="introStatValue">1+</span>
            <span className="introStatLabel">Years Experience</span>
          </div>
          <div className="introStatDivider"></div>
          <div className="introStat">
            <span className="introStatValue">1M+</span>
            <span className="introStatLabel">Records Processed</span>
          </div>
          <div className="introStatDivider"></div>
          <div className="introStat">
            <span className="introStatValue">45%</span>
            <span className="introStatLabel">Latency Reduced</span>
          </div>
        </div>

        <Link to='works' spy={true} smooth={true} offset={-50} duration={500}>
          <button className='btn'>
            <span className="btnPrompt">_</span>
            View My Work
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
          </button>
        </Link>
      </div>

      <img src={bg} alt="Avikal Singh" className="bg"/>
    </section>
  );
};

export default Intro;